export default __webpack_public_path__ + "img/dkOGiioC.52f4eff6.svg";